import { formatPrice } from 'utils/helpers';

// Operating cost is estimated per year and headlined per month; every
// surface that shows one shows it this way.
export function formatMonthlyOperatingCost(annualCost: number): string {
  return formatPrice(annualCost / 12);
}

export function formatAnnualOperatingCost(annualCost: number): string {
  return `${formatPrice(annualCost)} / year`;
}

export function formatAnnualOperatingCostLine(annualCost: number): string {
  return `${formatAnnualOperatingCost(annualCost)} (estimated)`;
}
